const API_URL = '/';


export default async function fetchApi(url, options) {
    try {
        const promise = await fetch(API_URL + url, options);
        const json = await promise.json();

        return { json };
    } catch (error) {
        console.error(error);
        return { error }
    }
}